import React from 'react';
import { toast } from 'react-toastify';

import { Button } from 'components/Button/RoundButton';
import { OuterContainer, SectionTitle } from '../styles';

import services from 'api/services';
const { MarketingEventService } = services;

export const MarketingStatistics = () => {
  // downloads data and opens it as a csv file
  const download = async () => {
    const res = await MarketingEventService.downloadMarketingStatistics();
    const blob = new Blob([res], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'MarketingStatistics.csv';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    toast.success('Marketing report downloaded successfully');
  };

  return (
    <OuterContainer>
      <SectionTitle>Marketing csv</SectionTitle>
      <Button
        small
        primaryBlue
        primaryGreenBorder
        removeMargin
        margin="15px 0 0 0px"
        onClick={() => {
          download();
        }}
      >
        Download
      </Button>
    </OuterContainer>
  );
};
